<footer class="footer footer-ov">
    <div class="container-fluid">
        <nav class="pull-left">
            <div class="app-component vcenter_text center-block">
                <p class="text-center text-muted foot-title" style="margin-bottom: 0px!important;color: white;">
                    <span>Fastlane</span> &copy; {{currentDate | date: 'yyyy'}}
                </p>
            </div>

        </nav>
    </div>
</footer>